import useDebounce from 'hooks/useDebounce';
import React from 'react'

export const SearchBar = ({
    keywords,
    placeholder,
    handleChange,
    handleSubmit
}) => {

    return (
        <div className="search-bar d-flex align-items-center jusitfy-content-start search-u">
            <svg height={22} aria-hidden="true" focusable="false" data-prefix="fas" data-icon="magnifying-glass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-inline--fa fa-magnifying-glass"><path fill="#6C889C" d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" className=""></path></svg>
            <input type="search" 
            // onKeyDown={handleSubmit} 
            name="search" className="form-control zaap-form-control borderless d-md-flex u-input"
                value={keywords} placeholder={placeholder}
                onChange={(e) => handleChange(e.target.value)}
            />
        </div>
    )
}
